// extracted by mini-css-extract-plugin
export default {"warningMessageWrapper":"UpdateMenuMessage_warningMessageWrapper__7I3Aa","blink":"UpdateMenuMessage_blink__Fjpzj"};